import React from "react";
import { Link } from "react-router-dom";
import green_switch_ea from "../assets/images/green_switch_ea.png";
import purpledot from "../assets/images/purple_squre_dots.b6e7dbcc.svg";
import yellowdot from "../assets/images/yellow_squre_dots.a8deef14.svg";
import achive from "../assets/images/achive.png";
import exam from "../assets/images/exam.svg";
import ana from "../assets/images/ana.svg";
import study from "../assets/images/study.svg";
import support from "../assets/images/support.svg";
import content from "../assets/images/content.svg";
import rates from "../assets/images/rates.svg";
import Excellence_2 from "../assets/images/Excellence_2.png";
import Img2 from "../assets/images/real-time.png";

function ExamReviewCourses() {
  return (
    <>
      <div className="overflow-hidden bg-placement-hero bg-cover w-full">
        <div className="max-w-7xl m-auto relative isolate px-6 pt-14 lg:px-8 h-[55%] md:h-[50%] lg:h-[80%] lg:mb-0 lg:pt-2 xl:pt-2">
          <img src={green_switch_ea} alt="" className="absolute object-contain inset-0 z-10 scale-75 lg:scale-[70%] -mt-14 ml-16 md:ml-32 md:-mt-32 lg:ml-52 lg:-mt-40 xl:-mt-[16rem] mt-[0px] xl:scale-[65%] xl:ml-96 2xl:ml-[22rem]" />
          <div className="mx-auto py-10 md:py-24 lg:py-48 relative z-10 text-white">
            <div className="mx-auto lg:max-w-5xl">
              <h1 className="text-left lg:text-5xl md:text-4xl text-3xl font-bold text-gray-700 lg:w-[38%] w-[90%] mb-2 lg:leading-[56px]"><span className="block">Best EA Exam</span><span className="block"> Review Courses</span></h1>

              <div className="scale-[60%] md:scale-75 lg:scale-100 mt-5 md:mt-4 lg:mt-10 flex flex-row gap-10 -ml-24 md:-ml-28 lg:ml-0 items-start justify-start gap-x-2 lg:gap-x-6">
                  <div className="box box_btn transform transition-transform duration-300 hover:scale-110" tabindex="0">
                      <Link to="https://www.kcglobed.com/contactus#EnquireForm"
                          className="relative lg:top-[33px] bg-[#fbb03b] transition duration-300 rounded-3xl bg-primary px-6 py-4 text-sm font-semibold text-gray-700 shadow-sm hover:bg-primary hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary pb-4 cursor-pointer"
                      >
                          Enquiry Now
                      </Link>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative bg-[#f2f2f2] p-4 md:p-8 lg:p-10 pt-[71px] pb-[51px]">
        <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
        <div className="flex flex-col items-center">
          <div tabindex="0">
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-10 items-center xs:max-w-xl lg:max-w-6xl group h-full ">
              <div className="flex flex-col ml-0 lg:ml-6">
                <h2 className="block flex flex-col text-3xl font-semibold text-gray-800 sm:text-4xl md:text-4xl">
                  <span className="uppercase text-xl">Achieve Success</span>
                </h2>
                <h2 style={{ lineHeight: '45px' }} className="block flex flex-col text-3xl font-semibold text-gray-800 sm:text-4xl md:text-4xl mb-3">
                  <span className="text-primary_text mt-3">
                    With KC GlobEd’s Enrolled Agent Review Course
                  </span>
                </h2>
                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                  Are you aspiring to become an Enrolled Agent (EA) and looking <span className="lg:block">for the best preparation resources? KC GlobEd’s Enrolled Agent</span>  <span className="lg:block">Review
                  Course is designed to help you pass the EA exam with</span> confidence and ease. Discover why we are considered the best <span className="lg:block">in the industry.</span> 
                </p>
              </div>
              <img src={achive} alt="" className="mt-6 lg:pl-10" />
            </div>
          </div>
        </div>
        <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
      </div>

      <div className="p-4 md:p-8 lg:mt-20">
        <div className="flex flex-col items-center">
          <div
            tabindex="0"
            className="transform transition-transform duration-300 hover:scale-110"
          >
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-10 items-center xs:max-w-xl lg:max-w-4xl group h-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
              <img
                src={Excellence_2}
                alt=""
                className="h-50 w-30 mb-6 lg:pr-10"
              />
              <div className="flex flex-col mr-6">
                <p className="text-xl font-semibold md:text-2xl mb-4">
                  <span>KC GlobEd’s </span>
                  <span className="text-primary_text lg:block text-4xl mt-2">
                    EA Review Course
                  </span>
                </p>

                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                  KC GlobEd offers one of the best EA review courses, providing
                  you with comprehensive and efficient study materials. Our
                  course is tailored to meet your needs, ensuring you have
                  everything required to excel in the EA exam.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="relative bg-[#f2f2f2] p-4 md:p-2 lg:mt-10">
      <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
        <div className="flex flex-col items-center">
          <div tabindex="0" className="lg:pt-[31px] lg:pb-[31px] pt-[31px] pb-[91px]">
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 items-center xs:max-w-xl lg:max-w-6xl group h-full">
              <div className="flex flex-col ml-0 lg:ml-0">
                <p className="block mb-3 flex flex-col text-3xl font-semibold text-gray-800 sm:text-4xl md:text-4xl pt-6 lg:pt-0">
                  <span className="uppercase text-xl">Features of the Best</span>
                  <span className="text-primary_text mt-1 mb-2">
                    Enrolled Agent Review Course
                  </span>
                </p>
                <p className="mb-3 text-[15px] text-base md:text-medium text-left text-dark_text">
                  <span className="font-bold">
                    Adaptive Learning Technology (T.E.E.E Technology): 
                  </span> Our course uses advanced adaptive learning technology to
                  personalize your study plan, focusing on areas where you need
                  the most improvement.
                </p>
                <p className="mb-3 text-[15px] text-base md:text-medium text-left text-dark_text">
                  <span className="font-bold">
                    Industry Expert Instructors:  
                  </span> Learn from top-notch instructors who bring real-world
                  experience and insights to the classroom.
                </p>
                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                  <span className="font-bold">Extensive Study Materials: </span>
                  Access a wealth of resources in our AI Powered LMS, including
                  detailed textbooks, practice questions, and video lectures, <span className="lg:block">all designed to cover every aspect of the EA exam.</span>
                  
                </p>
              </div>
              <img src={Img2} alt="" className="mt-6 lg:pl-10" />
            </div>
          </div>
        </div>
        <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
      </div>

      <div className="lg:py-1 lg:px-10 py-0 px-6">
        <div className="flex flex-col items-center">
          <div className="relative overflow-hidden">
            <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
              <div className="max-w-3xl text-center mx-auto">
                <h2 className="block text-3xl md:text-4xl font-bold text-gray-800">
                  <span className="uppercase text-xl">Comprehensive Enrolled</span>
                </h2>
                <h2 className="mt-2 block text-3xl md:text-4xl font-bold text-primary_text">
                  Agent Exam Review
                </h2>
                <p className="mt-4 text-md text-medium text-dark_text font-light">
                  Our Enrolled Agent exam review course provides a thorough
                  overview of the EA exam content, ensuring you are
                  well-prepared for each section. With KC GlobEd, you get:
                </p>
              </div>
            </div>
          </div>
          <div className="lg:max-w-3xl px-4 py-6 justify-center items-center">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-center items-center">
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(255, 247, 235)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                1
                              </h3>
                              <img className="w-16 h-16" src={exam} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Unlimited Practice Exams
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Simulate the real exam environment with our extensive
                          practice Exams
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(245, 249, 243)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                2
                              </h3>
                              <img className="w-16 h-16" src={ana} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Real-Time Analytics and Dashboards
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Track your progress and identify your strengths and
                          weaknesses with our real-time analytics.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(235, 243, 248)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                3
                              </h3>
                              <img className="w-16 h-16" src={study} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Flexible Study Options
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Choose from online, self-paced, or live courses to fit
                          your schedule and learning style.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:py-1 lg:px-10 py-0 px-6">
        <div className="flex flex-col items-center">
          <div className="relative overflow-hidden">
            <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
              <div className="max-w-4xl text-center mx-auto">
                <h2 className="block text-3xl md:text-4xl font-bold text-gray-800">
                  <span className="uppercase text-xl">KC GlobEd Offers</span>
                </h2>
                <h2 className="mt-2 block text-3xl md:text-4xl font-bold text-primary_text">
                  The Best EA Exam Review Courses
                </h2>
                <p className="mt-4 text-md text-medium text-dark_text font-light">
                  KC GlobEd’s commitment to quality and candidate success makes
                  us stand out as the provider of the best EA exam review
                  courses. Here’s why:
                </p>
              </div>
            </div>
          </div>
          <div className="lg:max-w-3xl px-4 py-6 justify-center items-center">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-center items-center">
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(255, 247, 235)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                1
                              </h3>
                              <img className="w-16 h-16" src={rates} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              High Pass Rates
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Our candidates consistently achieve high pass rates,
                          reflecting the effectiveness of our courses.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(245, 249, 243)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                2
                              </h3>
                              <img className="w-16 h-16" src={support} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Candidates Support
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Receive exceptional support from our dedicated team,
                          available to assist you every step of the way.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col lg:h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(235, 243, 248)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                3
                              </h3>
                              <img className="w-16 h-16" src={content} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              100% Content Aligned with IRS Blueprints
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Our EA Exam Review Course study material is 100% in
                          line with latest blue prints issued by Internal
                          Revenue Service (IRS) Department of USA.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative p-4 md:p-8 lg:p-10 bg-[#FFF7EB] pt-[71px] pb-[111px]">
        <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
        <div className="flex flex-col items-center">
          <div tabindex="0">
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8items-center xs:max-w-xl lg:max-w-6xl group h-full">
              <img
                src={Excellence_2}
                alt=""
                className="h-50 w-30 mb-6 lg:pr-10 mt-10 lg:mt-0"
              />
              <div className="flex flex-col lg:mr-6">
                <p className="block mb-3 flex flex-col text-3xl font-semibold text-gray-800 sm:text-4xl md:text-4xl ">
                  <span className="uppercase text-xl">Start Your Journey </span>
                  <span className="text-primary_text mt-1 mb-2">
                    With the Best Enrolled
                    Agent Review Course
                  </span>
                </p>

                <p className="mb-3 text-[15px] text-base md:text-medium text-left text-dark_text">
                  Don’t leave your EA exam success to chance. Enroll in KC
                  GlobEd’s Enrolled Agent Review Course today and take the first
                  step towards becoming a certified Enrolled Agent. With KC
                  GlobEd, you’re choosing the best enrolled agent review course
                  available.
                </p>
                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                  Explore more about our EA review courses and find out how KC
                  GlobEd can help you achieve your professional goals. Visit
                  www.kcglobed.com now!
                </p>
              </div>
            </div>
          </div>
        </div>
        <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
      </div>
    </>
  );
}
export default ExamReviewCourses;
